import { Http, Response, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class SubscriptionService {

  constructor(private authHttp: AuthHttp) { }

  getSubscriptionById(id: number){
    return this.authHttp.get('/api/subscription/id/'+id).map(res => res.json())
  }

  getAllSubscriptions(){
    return this.authHttp.get("/api/subscription/all").map(res => res.json());
  }

  getAllSubscriptionsByYear(year: number){
    return this.authHttp.get("/api/subscription/year/"+year).map(res => res.json());
  }

  getAllYearsOfSubscriptions(){
    return this.authHttp.get('/api/subscription/GetAllYearsOfSubscriptions').map( (res:any)=>{
      return { 'status': res.status, 'value': res.json()}
    })
  }

  getOpenSubscriptions(id: number){
    return this.authHttp.get("/api/subscription/"+id).map(res => res.json());
  }

  getSubscribedMembersEmail(id: number){
    return this.authHttp.get('/api/subscription/getSubscribedMembersEmail/'+id).map( (res:any)=>{
      return { 'status': res.status, 'value': res.json()}
    })
  }

  GetCurrentMembersForSubscription(subscriptionId: number){
    return this.authHttp.get("/api/subscription/members/"+subscriptionId).map(res=>res.json());
  }

  changeClosed(id: number, open: boolean){
    return this.authHttp.get("/api/subscriptionOpen/"+id+"/"+open).map(res => res.status);
  }

  createNewSubscription(subsctipion: any){
    return this.authHttp.post('/api/subscription/', subsctipion).map(res => res.json());
  }

  updateSubscription(subsctipion: any){
    return this.authHttp.put('/api/subscription/', subsctipion).map(res => res.json());
  }

  delete(id: number){
    return this.authHttp.delete('/api/subscription/'+id).map( res=> res.json());
  }

  addMembersToSubscription(members:any){
    // console.log("saving members to subscriptions");
    // console.log(members);
    return this.authHttp.post('/api/subscription/members/', members);
  }

  toggleSingleMemberToSubscription(memberid: number, sub_id: number, addtionals?:any){
    var extra = {
      Extras:0,
      ExtraNames:"",
      SingleRoom:false,
      AmountOfNonStdBikes:0,
      KindOfBikes:"",
      Remarks:"",
      PersonalTransport:false,
      ExtraQuestionResponse: false
    }

    if (addtionals){
      extra.Extras = addtionals.Extras,
      extra.ExtraNames = addtionals.ExtraNames
      extra.SingleRoom = addtionals.SingleRoom
      extra.PersonalTransport = addtionals.PersonalTransport

      if (addtionals.hasOwnProperty('AmountOfNonStdBikes')){
        extra.AmountOfNonStdBikes = addtionals.AmountOfNonStdBikes
      }
      if (addtionals.hasOwnProperty('KindOfBikes')){
        extra.KindOfBikes = addtionals.KindOfBikes;
      }
      if (addtionals.hasOwnProperty('Remarks')){
        extra.Remarks = addtionals.Remarks;
      }
      if (addtionals.hasOwnProperty('ExtraQuestionResponse')){
        extra.ExtraQuestionResponse = addtionals.ExtraQuestionResponse;
      }

    }

    // console.log("Extra before send in services :", extra);
    
    return this.authHttp.post('/api/subscription/subscribe/'+memberid+'/'+sub_id, extra).map( (res:any) => {
      return { 'status': res.status, 'value': res.json()}
    })
  }

  getMySubscriptions(memberid: number){
    return this.authHttp.get('/api/subscription/mySubscriptions/'+memberid).map(res => res.json());
  }

  updateExtrasCount(subscriptionId: number, memberId: number, count:number){
    return this.authHttp.put('/api/subscription/updateExtrasCount/'+subscriptionId+"/"+memberId+"/"+count,null).map(res => res.json());
  }

  updateExtrasNames(subscriptionId: number, memberId: number, names:string){
    var extraNames = {
      key: "extraNames",
      value: names
    }
    return this.authHttp.put('/api/subscription/updateExtrasNames/'+subscriptionId+"/"+memberId,extraNames).map(res => res.json());
  }

  updateAmountOfNonStdBikes(subscriptionId: number, memberId: number, count:number){
    return this.authHttp.put('/api/subscription/updateAmountOfNonStdBikes/'+subscriptionId+"/"+memberId+"/"+count,null).map(res => res.json());
  }

  updateKindOfBikes(subscriptionId: number, memberId: number, models:string){
    var change = {
      key: "kindOfBikes",
      value: models
    }
    return this.authHttp.put('/api/subscription/updateKindOfBikes/'+subscriptionId+"/"+memberId,change).map(res => res.json());
  }

  updateRemarks(subscriptionId: number, memberId: number, remark:string){
    var remarks = {
      key: "remarks",
      value: remark
    }
    return this.authHttp.put('/api/subscription/updateRemarks/'+subscriptionId+"/"+memberId,remarks).map(res => res.json());
  }

  downloadExcel(id: number) {
    return this.authHttp.get('/api/subscription/generateXlsx/'+id, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }

  sendPaymentEmail(id: number){
    return this.authHttp.get('/api/subscription/sendEmailtoAll/'+id).map(res => {
      return { 'status': res.status, 'value': res.json() }
    });
  }

  sendPaymentEmailToMember(memberid:number, eventid: number){
    return this.authHttp.get('/api/subscription/sendEmailto/'+memberid+'/'+eventid).map(res => {
      return { 'status': res.status, 'value': res.json() }
    });
  }

  subscriptionAmountForId(id:number){
    return this.authHttp.get('/api/subscription/subscriptionAmount/'+id).map( (res:any)=>{
      let value:any = {};
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    } )
  }

  subscriptionDepositAmountForId(id:number){
    return this.authHttp.get('/api/subscription/subscriptionDepositAmount/'+id).map( (res:any)=>{
      let value:any = {};
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    } )
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/subscription.service.ts